import { cloneElement, type CSSProperties, type FC, isValidElement, type ReactNode } from 'react';
import { Box, Flex, type MantineFontSize, type StyleProp, Text } from '@mantine/core';
import { CopyIcon } from '../CopyIcon';

type KeyValuePairProps = {
    label: string;
    value: ReactNode;
    size?: MantineFontSize;
    direction?: StyleProp<CSSProperties['flexDirection']>;
    isCopyEnabled?: boolean;
};

const getCopyValue = (value: ReactNode) => {
    if (typeof value === 'string' || typeof value === 'number') {
        return String(value);
    }

    return undefined;
};

const renderValue = (value: ReactNode, size: MantineFontSize, isCopyEnabled: boolean) => {
    const copyValue = isCopyEnabled ? getCopyValue(value) : undefined;
    let content: ReactNode;

    if (isValidElement<{ style?: CSSProperties }>(value)) {
        content = cloneElement(value, {
            style: {
                fontSize: 'inherit',
                lineHeight: 'inherit',
                // ...value.props.style,
            },
        });
    } else {
        content = <Box size={size}>{value}</Box>;
    }

    if (copyValue === undefined || copyValue === '') {
        return content;
    }

    return (
        <Flex
            gap={4}
            align='center'
            wrap='nowrap'
        >
            {content}
            <CopyIcon
                value={copyValue}
                size='sm'
                iconSize={14}
            />
        </Flex>
    );
};

export const KeyValuePair: FC<KeyValuePairProps> = ({
    label,
    value,
    size = 'sm',
    direction = 'column',
    isCopyEnabled = false,
}) => {
    return (
        <Flex
            gap={direction === 'row' ? 'xs' : 0}
            fz={size}
            direction={direction}
            align={direction === 'row' ? 'center' : undefined}
        >
            <Text
                size={size}
                c='dimmed'
            >
                {label}
            </Text>

            {renderValue(value, size, isCopyEnabled)}
        </Flex>
    );
};
